<template>
  <div class="ecommerce_product_select_category">
    <v-btn
      small
      class="ma-1"
      :color="currentCategory != 'all' ? 'grey' : 'primary'"
      depressed
      :outline="currentCategory != 'all'"
      @click="onChangeCategory('all')"
    >
      {{ $t('All') }}
      <template v-if="stat && stat.all > 0 && !selectedBot.useketshop">({{ stat.all }})</template>
    </v-btn>
    
    <v-btn
      small
      v-if="!isKetShop"
      class="ma-1"
      :color="currentCategory != 'soldout' ? 'grey' : 'primary'"
      depressed
      :outline="currentCategory != 'soldout'"
      @click="onChangeCategory('soldout')"
    >
      {{ $t('almost sold out') }}
      <template v-if="stat && stat.soldout > 0">({{ stat.soldout }})</template>
    </v-btn>

    <v-btn
      small
      v-if="!isKetShop"
      class="ma-1"
      :color="currentCategory != 'sales' ? 'grey' : 'primary'"
      depressed
      :outline="currentCategory != 'sales'"
      @click="onChangeCategory('sales')"
    >
      {{ $t('Sale') }}
      <template v-if="stat && stat.sales > 0">({{ stat.sales }})</template>
    </v-btn>

    <v-btn
      small
      v-if="isKetShop"
      class="ma-1"
      :color="currentCategory != '-1' ? 'grey' : 'primary'"
      depressed
      :outline="currentCategory != '-1'"
      @click="onChangeCategory('-1')"
    >
      {{ $t('Uncategorize') }}
      <template v-if="stat && stat.sales > 0">({{ stat.sales }})</template>
    </v-btn>

    <template v-for="(category, index) in categorylist">
      <v-btn
        small
        class="ma-1"
        :color="currentCategory != category.id ? 'grey' : 'primary'"
        depressed
        :outline="currentCategory != category.id"
        :key="'category_' + index"
        @click="onChangeCategory(category.id)"
      >
        <span v-if="category.display_name">
          {{ category.display_name }}<span class="ml-1">({{ category.name }})</span>
        </span>
        <span v-else>
          {{ category.name }}
        </span>
      </v-btn>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    value: [String, Number],
    categories: Array,
    isKetShop: Boolean,
    stat: {
      default: {
        all: 0,
        soldout: 0,
        sales: 0
      },
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  data: function() {
    return {
      categorylist: this.categories,
      currentCategory: this.value
    }
  },
  methods: {
    onChangeCategory: function(index) {
      let vm = this
      vm.currentCategory = index
      vm.$emit('onChangeCategory', vm.currentCategory)
    }
  },
  watch: {
    value: function() {
      this.currentCategory = this.value
    },
    categories: function() {
      this.categorylist = this.categories
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/FilterCategory.vue